import React from "react";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import trans from "../../../utils";
import { Tag } from "antd";

export default function POIsGeneral({ poidetails }) {
	function capitalizeWords(str) {
		if (!str) return "";
		return str
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");
	}

	return (
		<>
			<div className="row">
				<div className="col-lg-12">
					<p className="fs-16 fw-500 brand-700 text-uppercase">
						{trans("Basic Details")}
					</p>
					<div className="display-border">
						<PopupBodyItem title={trans("poi name")} item={poidetails?.name} />
						<PopupBodyItem
							title={trans("Code")}
							item={poidetails?.code || "- - - -"}
						/>
						<PopupBodyItem
							title={trans("poi status")}
							item={
								<Tag color={poidetails?.status ? "green" : "default"}>
									{poidetails?.status ? trans("Active") : trans("Inactive")}
								</Tag>
							}
						/>
						<PopupBodyItem
							title={trans("poi type")}
							item={trans(poidetails?.type)}
						/>
						<PopupBodyItem
							title={trans("region")}
							item={`${trans(capitalizeWords(poidetails?.city))} - ${trans(
								capitalizeWords(poidetails?.state)
							)}`}
						/>
						<PopupBodyItem
							title={trans("created by")}
							item={poidetails?.createdBy?.name}
						/>

						<PopupBodyItem
							title={trans("updated by")}
							item={
								poidetails?.updatedBy ? poidetails?.updatedBy?.name : "- - - -"
							}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
